import { useCreateMutation } from '../../../../../../lib/utils/createMutation';
import { UseMutationResult } from '@tanstack/react-query';
import { AccountAdminApiV2 } from '../../../../../../lib/api/account/admin/AccountAdminApiV2';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { AccountAdminCreateRequest, AccountAdminCreateResponse } from '../../types/AccountAdminFormType';

import { AccountAdminCreateSuccess } from '../../constants';
import { ErrorResponseType, extractErrorMessage } from '../../../../../../lib/utils/checkErrorResponse';

const useCreateAdminAccount = (): UseMutationResult<
  AccountAdminCreateResponse,
  unknown,
  AccountAdminCreateRequest,
  unknown
> => {
  const navigate = useNavigate();

  return useCreateMutation<AccountAdminCreateRequest, AccountAdminCreateResponse>({
    queryKey: ['createAccountAdmin'],
    apiFunction: (payload: AccountAdminCreateRequest) => AccountAdminApiV2.createAccountAdminDetailInfo(payload),
    onSuccess: () => {
      message.success(AccountAdminCreateSuccess);
      navigate('/account/admin/list');
    },
    onError: (error: AxiosError) => {
      const errorMessage = extractErrorMessage(error as ErrorResponseType);
      message.error(errorMessage);
    },
  });
};

export default useCreateAdminAccount;
